import React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Rating,
  Typography,
} from "@mui/material";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ item, children }) => {
  const [selectedType, setselectedType] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  let image = "",
    price = "",
    originalPrice = "",
    redirectToEdit = "";
  if (item?.productType === "Single") {
    image = item?.images?.featuredImage?.src;
    price = item?.price;
    originalPrice = item?.originalPrice;
    redirectToEdit = `/edit-product-single/${item?._id}`;
  } else if (item?.productType === "WithSize") {
    image = item?.images?.featuredImage?.src;
    price = item?.variations[0]?.price;
    originalPrice = item?.variations[0]?.originalPrice;
    redirectToEdit = `/edit-product-size/${item?._id}`;
  } else if (item?.productType === "WithColor") {
    image = item?.variations[0]?.images?.featuredImage?.src;
    price = item?.variations[0]?.price;
    originalPrice = item?.variations[0]?.originalPrice;
    redirectToEdit = `/edit-product-color/${item?._id}`;
  } else if (item?.productType === "WithBoth") {
    image = item?.variations[0]?.images?.featuredImage?.src;
    price = item?.variations[0]?.variations[0]?.price;
    originalPrice = item?.variations[0]?.variations[0]?.originalPrice;
    redirectToEdit = `/edit-product-both/${item?._id}`;
  }

  const [featuredImage, setfeaturedImage] = useState(image);

  return (
    <Grid item xs={3} key={item._id + "imde"}>
      <Card
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          zIndex: isHovered ? 5 : 1,
          position: "relative",
          transition: "all 0.3s ease-out",
          transform: isHovered ? "scale(1.05)" : "",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        border={"1px solid red"}
        onClick={() => navigate("/single-product/" + item._id)}
      >
        <img
          src={featuredImage}
          style={{
            width: "full",
            height: "300px",
            objectFit: "cover",
            cursor: "pointer",
            objectPosition: "center",
            opacity: isHovered ? 0.8 : 1,
            transition: "opacity 0.3s",
          }}
          alt="x"
        />
        {isHovered && (
          <div
            style={{
              padding: "3px",
              background: "white",
              position: "absolute",
              bottom: "175px",
              width: "85%",
              display: "flex",
              gap: "5px",
              alignItems: "center",
              margin: "10px 0px",
            }}
          >
            <>{children}</>
          </div>
        )}
        <br />
        <br />
        <Typography variant="h6" fontSize={"18px"}>
          {item.name.substring(0, 44) + "..."}
        </Typography>
        <p
          dangerouslySetInnerHTML={{
            __html: item?.shortDescription?.substring(0, 56) + "...",
          }}
        ></p>
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          ₹ {price || "NA"} &nbsp;&nbsp;&nbsp;
        </Typography>
        <Rating
          value={
            item?.reviews?.reduce((acc, el) => acc + el.rating, 0) /
            item?.reviews?.length
          }
          readOnly
        />

        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            gap: 3,
          }}
        ></Box>
      </Card>
    </Grid>
  );
};
export default ProductCard;
